import { gql } from '@apollo/client';

export const EXPORT_FUNDER_SCHOOL_EDUCATOR = gql`
  query ExportFunderSchoolEducator($input: ExportArgs!) {
    exportFunderSchoolEducator(input: $input) {
      id
      name
      class
      focusSubjects {
        id
        name
      }
      grades {
        id
        name
        value
      }
      programme {
        id
        name
      }
      serviceProviders {
        id
        name
      }
      subject {
        id
        name
        subjectGradeReference
      }
      schoolEducator {
        id
        year
        term
        circuit {
          id
          name
        }
        district {
          id
          name
        }
        emisNumber
        educatorName
        attendanceRate
        daysAbsent
        institution {
          id
          emisNumber
          name
        }
      }
    }
  }
`;
